import { inAndOut } from 'ol/easing';
import autoRun from '@giswebgroup/ki-wcp-base/src/decorators/autoRun';
import { isEqual } from 'lodash-es/lang';
import { transform } from 'ol/proj';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import {unByKey} from "ol/Observable";
import _AddOn from './_AddOn';
import StationsLabelLayer from './StationsLabelLayer';
import StationsMarkerLayer from './StationsMarkerLayer';
import MultiSelectionToggle from './MultiSelectionToggle';
import './ki-station-info';
import './ki-station-info-alarmstatus';
import './ki-station-gw-info';
import './ki-station-gw-info-inactive';
import './ki-station-gw-info-public';
import nls from '../../locales/index.nls';
// TODO
export default
@i18n(nls)
class KiStationsLayer extends _AddOn {
  static get properties() {
    return {
      zIndex: { type: String, attribute: 'z-index' },

      stations: { type: Array },
      labelTemplate: { type: String },
      tagMarkers: { type: Object },
      tagSelectedMarkers: { type: Object },
      currentStation: { type: Object },
      infoTag: { type: String }, // tooltip component
      selection: { type: Array },
      multiSelectable: { type: Boolean },
      noAutoZoom: { type: Boolean },
      displayInLayerControl: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.mapLayers = [];
    this.stations = [];
    this.selection = [];
    this.zIndex = 100;
    this.idProperty = 'station_no';
    this.duration = {};
    this.noAutoZoom=false;
  }

  @autoRun('selection')
  updateSelection() {
    if (this.multiSelectionToggle) {
      this.multiSelectionToggle.selection = this.selection;
    }
  }

  _afterMapCreated() {
    super._afterMapCreated();
    this._initPopup();
  }

  _create() {
    this._createLabelLayer();
    this._createMakerLayer();
    this.multiSelectable && this._createSelectionControl();
    this.map.getLayers().extend(this.mapLayers);
  }

  _createLabelLayer() {
    this.stationsLabelLayer = new StationsLabelLayer({
      name: this.i18n.t('Labels'),
      displayInLayerControl: true,
      group: 'Information',
      visible: false,
      stations: this.stations,
      zIndex: this.zIndex,
      labelTemplate: this.labelTemplate,
    });
    this.mapLayers.push(this.stationsLabelLayer);
  }

  _createMakerLayer() {
    this.stationsMarkerLayer = new StationsMarkerLayer({
      name: this.i18n.t('stations'),
      displayInLayerControl: this.displayInLayerControl,
      dynamicMarkerSize: this.dynamicMarkerSize,
      group: 'Layers',

      tagMarkers: this.tagMarkers,
      zIndex: this.zIndex + 1,
      currentStation: this.currentStation,
    });

    this.stationsMarkerLayer.on('change:source', () => {
      if(this.noAutoZoom) {
        this.stationsMarkerLayer.changeCounter<=1 && this.autoFitStationsExtent()
      }else{
        this.autoFitStationsExtent()
      };
    });
    this.stationsMarkerLayer.stations = this.stations;
    this.mapLayers.push(this.stationsMarkerLayer);


    // eslint-disable-next-line consistent-return
    this.clickEvent = this.map.on('singleclick', evt => {
      let station;
      const stations = [];
      this.map.forEachFeatureAtPixel(evt.pixel, feature => {
          if (feature && feature.station) {
            stations.push(feature.station)
          }
        },
        { layerFilter: layer => layer === this.stationsMarkerLayer },
      );

      if (stations.length>0) {
        this.dispatchEvent(
          new CustomEvent('station-click', {
            detail: {
              value: `${stations[0].site_no}/${stations[0].station_no}`,
              data: stations[0],
              // TODO station
            },
          }),
        );
        return false; // skip rest listener;
      }
    });
  }

  _initPopup() {
    let activePopup = false;
    // eslint-disable-next-line consistent-return
    this.hoverEvent = this.map.on('pointermove', evt => {
      if (!this.stationsMarkerLayer) {
        return false;
      }
      const stations = [];
      this.map.forEachFeatureAtPixel(
        evt.pixel,
        feature => {
          this.map.getTargetElement().style.cursor = 'pointer';
          if (feature && feature._hoverStyle) {
            feature.setStyle(feature._hoverStyle);
          }
          if (feature && feature.station) {
            stations.push(feature.station);
            return true;
          }
        },
        { layerFilter: layer => layer === this.stationsMarkerLayer },
      );

      if (stations.length > 0) {
        activePopup = true;
        this.element.stations = stations;
        this.map.dispatchEvent({
          type: 'show-popup',
          detail: {
            coordinate: this.map.getCoordinateFromPixel(evt.pixel),
            element: this.element,
          },
        });
      }else if(activePopup) {
        activePopup = false;
        this.map.dispatchEvent({
          type: 'close-popup',
          detail: {
            element: this.element,
          },
        });
      }
      // prevent other listener
      return false;
    });
  }

  _createSelectionControl() {
    this.multiSelectionToggle = new MultiSelectionToggle([this.stationsMarkerLayer], {
      idProperty: this.idProperty,
      displayInLayerControl: true,
      tagSelectedMarkers: this.tagSelectedMarkers,
      onSelection: selection => {
        this.dispatchEvent(new CustomEvent('selection', { detail: { selection } }));
      },
      options: [
        { icon: 'ki ki-mouse-pointer', label: this.i18n.t('move_in_map'), value: 'mover' }, // TODO i18n ?
        {
          icon: 'ki ki-object-group',
          label: this.i18n.t('Select_stations'),
          value: 'selector',
        },
      ],
    });
    this.map.addControl(this.multiSelectionToggle);
    this.multiSelectionToggle.selection = this.selection;
  }

  _tear() {
    this.multiSelectionToggle = null;
    this.stationsLabelLayer = null;
    this.stationsMarkerLayer = null;

    this.mapLayers.forEach(l => this.map.removeLayer(l));
    this.map.removeControl(this.multiSelectionToggle);
    this.mapLayers = [];
    unByKey(this.clickEvent);
    unByKey(this.hoverEvent);
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);
    this.element = document.createElement(this.infoTag || 'ki-station-info');
    if (this.map) {
      // TODO how to update. dirty code

      if (_changedProperties.has('stations')) {
        if(this.stationsMarkerLayer) this.stationsMarkerLayer._legends = null;
        if(this.mapLayers.length){
          this.duration = { duration: 500 };
        }
        this.mapLayers.forEach(l => {
          l.stations = this.stations;
        });
      }

      if (_changedProperties.has('tagMarkers')) {
        if (this.stationsMarkerLayer) {
          this.stationsMarkerLayer.tagMarkers = this.tagMarkers;
        }
      }



      if (_changedProperties.has('labelTemplate')) {
        if (this.stationsMarkerLayer) {
          this.stationsLabelLayer.set("labelTemplate", this.labelTemplate);
        }
      }

      if (_changedProperties.has('tagSelectedMarkers')) {
        if (this.multiSelectionToggle) {
          this.multiSelectionToggle.tagSelectedMarkers = this.tagSelectedMarkers;
        }
      }
    }
  }

  autoFitStationsExtent(force) {
    const source = this.stationsMarkerLayer.getSource();
    const { map } = this;
    if (map.isRendered() && source.getFeatures().length > 0) {
      const extent = source.getExtent();
      if (force || !isEqual(extent, this.__preExtent)) {
        // compare with previous extent, only fit when it's changed.
        // will not loss user operation.
        this.__preExtent = extent;
        map.getView().fit(extent, {
          ...{
            nearest: true,
            easing: inAndOut,
            padding: [100, 100, 100, 100],
            size: map.getSize(),
            maxZoom: 18,
          },
          ...this.duration,
        });
      }
    }
  }
}

customElements.define('ki-stations-layer', KiStationsLayer);
